import React from 'react';
import ClientInvoiceItem from '../Domain/ClientInvoiceItem.js';
import serviceHelper from '../Helpers/serviceHelper.js';
import AuthService from './authService.js';
import ClientInvoiceAdminItem from '../Domain/ClientInvoiceAdminItem.js';
import dateTimeHelper from '../Helpers/datetimeHelper.js';
import OutstandingInvoiceItem from '../Domain/OutstandingInvoiceItem.js';
import AppliedInvoiceItem from '../Domain/AppliedInvoiceItem.js';
import AppliedPaymentsExportItem from '../Domain/AppliedPaymentsExportItem.js';
import OutstandingTpRelatedInvoiceItem from '../Domain/OutstandingTpRelatedInvoiceItem.js';
import SearchParams from '../Elements/SearchParams';
import ClientInvoiceSearchParams from '../Contents/Operations/ClientInvoiceAdmin/ClientInvoiceSearchParams';
import ClientPaymentClientInvoiceSearchParams from '../Contents/Finance/ClientPayment/ClientPaymentClientInvoiceSearchParams';
import AppliedPaymentsExportSearchParams from '../Contents/Finance/ClientPayment/AppliedPaymentsExportSearchParams';
import AssignmentSearchParams from '../Contents/Operations/Projects/Assignments/AssignmentSearchParams';

export default class ClientInvoiceService extends React.Component {
  static PostClientInvoice(item) {
    const searchParams = new SearchParams(item.SearchParameters, AssignmentSearchParams, '', '', 0, 0);

    delete item.SearchParameters;
    const url = `/api/ClientInvoice/PostClientInvoiceAsync/?searchParams=${searchParams.serializeForBackendCall()}`;

    const clientInvoice = serviceHelper.ConvertAllPropertyToString(item);
    const clientInvoiceJson = JSON.stringify(clientInvoice);
    return AuthService.getInstance().CallBackendFunctionPost(url, clientInvoiceJson);
  }

  static GetInvoiceList(clientId) {
    return AuthService.getInstance().CallBackendFunction(
      `/api/ClientInvoice/GetClientInvoiceByClientId?clientId=${encodeURIComponent(clientId)}&clearCache=true`
    );
  }

  static ConvertDBItem(items) {
    const convertedItems = [];
    if (items !== null) {
      items.forEach((item) => {
        const newItem = new ClientInvoiceItem(item);
        convertedItems.push(newItem);
      });
    }

    return convertedItems;
  }

  static GetListBySearching(orderById, orderDir, pageNumber, numberOfElements, searchItem, clearCache = false) {
    const searchParams = new SearchParams(searchItem, ClientInvoiceSearchParams, orderById, orderDir, pageNumber, numberOfElements);
    return AuthService.getInstance().CallBackendFunction(
      `/api/ClientInvoice/GetListBySearching?searchParams=${searchParams.serializeForBackendCall()}&clearCache=${clearCache}`
    );
  }

  static ConvertDBItems(items) {
    const convertedItems = [];
    if (items !== null) {
      items.forEach((item) => {
        const newItem = new ClientInvoiceAdminItem(item);
        convertedItems.push(newItem);
      });
    }

    return convertedItems;
  }

  static AddToInvoice(item) {
    const searchParams = new SearchParams(item.SearchParameters, AssignmentSearchParams, '', '', 0, 0);
    const JSONItem = JSON.stringify(item);
    delete item.SearchParameters;

    return AuthService.getInstance().CallBackendFunctionPost(
      `/api/ClientInvoice/AddToInvoice?searchParams=${searchParams.serializeForBackendCall()}`,
      JSONItem
    );
  }

  static GetById(invoiceId) {
    return AuthService.getInstance().CallBackendFunction(
      `/api/ClientInvoice/GetClientInvoiceByIdAsync?clientInvoiceId=${encodeURIComponent(invoiceId)}`
    );
  }

  static GetByInvoiceId(id) {
    return AuthService.getInstance().CallBackendFunction(`/api/ClientInvoice/GetById/${id ? id : 0}`);
  }

  static EditInvoice(item) {
    const searchParams = new SearchParams(item.SearchParameters, AssignmentSearchParams, '', '', 0, 0);

    delete item.SearchParameters;
    const url = `/api/ClientInvoice/GenerateInvoice/?searchParams=${searchParams.serializeForBackendCall()}`;

    const contacts = item.ClientContacts;
    const clientInvoice = serviceHelper.ConvertAllPropertyToString(item);
    const clientInvoiceJson = JSON.stringify(clientInvoice);
    item.ClientContacts = contacts;

    return AuthService.getInstance().CallBackendFunctionPost(url, clientInvoiceJson);
  }

  static CancelInvoice(id, comment) {
    return AuthService.getInstance().CallBackendFunctionPost(
      `api/ClientInvoice/CancelInvoice/${id}`,
      JSON.stringify(comment)
    );
  }

  static FinalizeInvoice(editedItem) {
    const finalizeItem = {
      InvoiceId: editedItem.CiId,
      FulfillmentDate: dateTimeHelper.toYYYYsMMsDD(editedItem.FulfillmentDate),
      Comment: editedItem.Comment,
    };
    return AuthService.getInstance().CallBackendFunctionPost(
      `api/ClientInvoice/FinalizeInvoice`,
      JSON.stringify(finalizeItem)
    );
  }

  static FinalizeSelectedInvoice(editedItem) {
    return AuthService.getInstance().CallBackendFunctionPost(
      `api/ClientInvoice/FinalizeSelectedInvoiceAsync`,
      JSON.stringify(editedItem)
    );
  }

  static BulkFinalizeInvoice(editedItem) {
    return AuthService.getInstance().CallBackendFunctionPost(
      `api/ClientInvoice/InvoiceBulkFinalizationAsync`,
      JSON.stringify(editedItem)
    );
  }

  static GetInvoicePdfById(item) {
    return AuthService.getInstance().CallBackendFunction(
      `/api/ClientInvoice/GetInvoicePdfById/?searchParams=${JSON.stringify(item)}&clearCache=false`
    );
  }

  static ListOutstanding(orderById, orderDir, pageNumber, numberOfElements, searchItem, clearCache) {
    const searchParams = new SearchParams(searchItem, ClientPaymentClientInvoiceSearchParams, orderById, orderDir, pageNumber, numberOfElements);
    return AuthService.getInstance().CallBackendFunction(
      `/api/ClientInvoice/ListOutstandingAsync/?searchParams=${searchParams.serializeForBackendCall()}&clearCache=false`
    );
  }

  static ConvertOutstandingDBItems(items) {
    const convertedItems = [];
    if (items !== null) {
      items.forEach((item) => {
        const newItem = new OutstandingInvoiceItem(item);
        convertedItems.push(newItem);
      });
    }

    return convertedItems;
  }

  static ListApplied(orderById, orderDir, pageNumber, numberOfElements, searchItem, clearCache) {
    searchItem.PaymentIdsString = searchItem.ClientPaymentIds.join(',');
    const searchParams = new SearchParams(searchItem, ClientPaymentClientInvoiceSearchParams, orderById, orderDir, pageNumber, numberOfElements);
    return AuthService.getInstance().CallBackendFunction(
      `/api/ClientInvoice/ListAppliedAsync/?searchParams=${searchParams.serializeForBackendCall()}&clearCache=${clearCache}`
    );
  }

  static ListAppliedForExport(orderById, orderDir, pageNumber, numberOfElements, searchItem, clearCache) {
    const searchParams = new SearchParams(searchItem, AppliedPaymentsExportSearchParams, orderById, orderDir, pageNumber, numberOfElements);
    return AuthService.getInstance().CallBackendFunction(
      `/api/ClientInvoice/ListAppliedForReportAsync/?searchParams=${searchParams.serializeForBackendCall()}&clearCache=${clearCache}`
    );
  }

  static ExportPaymentAppliedInvoices(item) {
    return AuthService.getInstance().CallBackendFunction(
      `/api/ClientInvoice/ExportPaymentAppliedInvoicesAsync/?searchParams=${JSON.stringify(item)}`
    );
  }

  static ConvertAppliedDBItems(items) {
    const convertedItems = [];
    if (items !== null) {
      items.forEach((item) => {
        const newItem = new AppliedInvoiceItem(item);
        convertedItems.push(newItem);
      });
    }

    return convertedItems;
  }

  static ConvertAppliedExportDBItems(items) {
    const convertedItems = [];
    if (items !== null) {
      items.forEach((item) => {
        const newItem = new AppliedPaymentsExportItem(item);
        convertedItems.push(newItem);
      });
    }

    return convertedItems;
  }

  static ExportInvoicePdfs(item) {
    return AuthService.getInstance().CallBackendFunctionPost(
      `/api/ClientInvoice/ExportInvoicePdfAsync/?searchParams=${JSON.stringify(item)}`
    );
  }

  static ExportAdminExcelAsync(searchItem) {
    const url = `/api/ClientInvoice/ExportAdminExcelAsync?searchItem=${JSON.stringify(searchItem)}&clearCache=true`;
    return AuthService.getInstance().CallBackendFunction(url);
  }
}
